module.exports = __webpack_public_path__ + "img/liotron_artic.6eb86716.png";